// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"224":"361b7ae52f7e4d0a","551":"1d970c4e8879bc9b","891":"f65ce4bc2941af36"}[chunkId] + ".css";
};